import Vue from 'vue';

const requireComponent = require.context(
    './gfb/shared/components/ajanlatiadatok/biztosito_specifikus/kgfb',
    true,
    /AjanlatAdatok[\w]+\.vue/,
);
requireComponent.keys().forEach((element) => {
    const path = element.replace(/^\.\//, '')
        .replace(/\.\w+$/, '')
        .split('/');
    const componentName = path[1];
    const biztosito = path[0];

    Vue.component(componentName, () => import('./gfb/shared/components/ajanlatiadatok/'
    + `biztosito_specifikus/kgfb/${biztosito}/${componentName}`));
});
